// Global constants
export const NEW_GENERIC_INPUT_DIALOG =
  "genericInputDialog/NEW_GENERIC_INPUT_DIALOG";

// Local constants
export const SET_CONTENT = "SET_CONTENT";
export const SHOW_DIALOG = "SHOW_DIALOG";
export const SET_RESOLVE = "SET_RESOLVE";
export const RESET_STATE = "RESET_STATE";
